import { type AxiosInstance } from 'axios';

import { type IThrowsError } from '@gbs-monorepo-packages/common';

export interface ITermsVersionDTO {
  version: number;
}

export interface IAcceptTermsDTO {
  termsVersion: number;
}

export interface ITermsServiceUrls {
  getLatestVersion: string;
  acceptTerms: string;
}

const defaultUrl = {
  getLatestVersion: 'api/terms/latest-version',
  acceptTerms: 'api/terms/accept',
};

export interface ITermsService {
  getLatestVersion: () => Promise<ITermsVersionDTO>;
  acceptTerms: (dto: IAcceptTermsDTO) => Promise<void>;
}

export const createTermsService = (
  api: AxiosInstance,
  urls?: Partial<ITermsServiceUrls>
): ITermsService => {
  const url = { ...defaultUrl, ...urls };

  return {
    getLatestVersion: async (): Promise<ITermsVersionDTO> => {
      const { data } = await api
        .get<{ data: ITermsVersionDTO }>(url.getLatestVersion)
        .then((resp) => resp.data)
        .catch((err: IThrowsError) => {
          throw err;
        });

      return data;
    },

    acceptTerms: async ({ termsVersion }: IAcceptTermsDTO): Promise<void> => {
      await api
        .post(url.acceptTerms, { termsVersion })
        .catch((err: IThrowsError) => {
          throw err;
        });
    },
  };
};
